var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchedule = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.258 21q.73 0 1.236-.491a1.6 1.6 0 0 0 .506-1.2V6.782c0-.472-.168-.985-.505-1.312a1.7 1.7 0 0 0-1.236-.491h-1.334V3h-1.482v1.98h-7.3V3H6.698v1.98h-.965c-.486 0-.889.136-1.226.463C4.17 5.771 4 6.283 4 6.756V19.28c0 .473.144.893.482 1.22.337.328.773.471 1.26.471zm-.096-1.53-12.336-.002a.29.29 0 0 1-.204-.09.27.27 0 0 1-.093-.198l-.003-8.654h12.933v8.656a.27.27 0 0 1-.093.198.3.3 0 0 1-.204.09m.297-10.349H5.529l-.007-2.353q0-.108.092-.198c.092-.09.13-.09.204-.09l12.36.015s.104 0 .204.09q.092.09.092.198z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchedule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule.f644229a.svg";